import { useQuestionizerStore } from "../types/state.ts";
import Radio from "./radio.tsx";
import Toggle from "./toggle.tsx";

export default function InputGebaeudeTyp (props: {
  id: number,
  label?: string,   
  label_einfamilienhaus?: string,   
  icon_einfamilienhaus: string, 
  icon_einfamilienhaus_active?: string,
  label_mehrfamilienhaus?: string,   
  icon_mehrfamilienhaus: string, 
  icon_mehrfamilienhaus_active?: string, 
  onBlur?: ()=>void}){
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);
  const gebaeude = useQuestionizerStore((state) => state.gebaeude);
  const setGebaeude = useQuestionizerStore((state) => state.setGebaeude);

  const label_einfamilienhaus = props.label_einfamilienhaus || useQuestionizerStore((state) => state.E('input-gebaeudetyp--einfamilienhaus'));
  const label_mehrfamilienhaus = props.label_mehrfamilienhaus ||  useQuestionizerStore((state) => state.E('input-gebaeudetyp--mehrfamilienhaus'));

  return <div>
      <fieldset className="section__inputs justify-center section__inputs--grid mb-6">
          <legend>{props.label}</legend>
          <div className="hidden md:block sm:col-span-2 md:block"></div>
          <Radio name="gebaeudetyp" id={props.id+'-efh'} label={label_einfamilienhaus} icon={props.icon_einfamilienhaus}
                  icon_active={props.icon_einfamilienhaus_active} value={gebaeude == "Einfamilienhaus"}
                  onBlur={props.onBlur}
                  onChange={(_) => {
                      setGebaeude("Einfamilienhaus");
                      updateValidation();
                      //setValidation(props.id, {message:"", valid: true});
                  }}/>
          <Radio name="gebaeudetyp" id={props.id+'-mfh'} label={label_mehrfamilienhaus} icon={props.icon_mehrfamilienhaus}
                  icon_active={props.icon_mehrfamilienhaus_active} value={gebaeude == "Mehrfamilienhaus"}
                  onBlur={props.onBlur}
                  onChange={(_) => {
                      setGebaeude("Mehrfamilienhaus");
                      updateValidation();
                      //setValidation(props.id, {message:"", valid: true});
                  }}/>
      </fieldset>
  </div>
}